export const pkg = {
  name: 'isomorphic-git',
  version: '1.38.8',
  agent: 'git/isomorphic-git@1.38.8',
}
